module.exports = __webpack_public_path__ + "static/media/remove.dbe09772.svg";